var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsComboFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.025 29.7188C37.2301 29.4628 37.5277 29.2978 37.8534 29.2592C38.1791 29.2206 38.507 29.3116 38.7663 29.5126L38.8838 29.6163L43.8838 34.6163C44.078 34.8107 44.2028 35.0638 44.2387 35.3363L44.25 35.5001V41.7501C44.25 42.0562 44.1376 42.3517 43.9341 42.5805C43.7307 42.8093 43.4503 42.9555 43.1463 42.9913L43 43.0001H22.9725L22.835 42.9888L22.6975 42.9638L22.5638 42.9213L22.4325 42.8638L22.3075 42.7901L22.19 42.7026L22.115 42.6338L22.025 42.5313L21.945 42.4201L21.8775 42.3001L21.8575 42.2563L21.8075 42.1276L21.7738 41.9951L21.755 41.8601L21.75 41.7226L21.7613 41.5851L21.785 41.4538C21.7975 41.4038 21.8125 41.3576 21.8287 41.3138L21.8862 41.1826L21.96 41.0576L26.96 33.5576C27.1139 33.3259 27.3407 33.1521 27.6044 33.0638C27.8682 32.9755 28.1539 32.9777 28.4163 33.0701L28.5587 33.1326L32.655 35.1801L37.0238 29.7188H37.025Z",
    fill: "#19C48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.04 22.2001C37.2474 21.9509 37.5435 21.792 37.8658 21.7571C38.1881 21.7221 38.5114 21.8137 38.7675 22.0126L38.8837 22.1163L43.8837 27.1163C44.1079 27.3413 44.2381 27.6431 44.2478 27.9605C44.2575 28.278 44.146 28.5872 43.9359 28.8254C43.7259 29.0636 43.433 29.2129 43.1169 29.2431C42.8007 29.2732 42.485 29.1818 42.2337 28.9876L42.1162 28.8838L38.0837 24.8526L32.71 31.3001C32.5467 31.4959 32.3276 31.6371 32.0818 31.7048C31.836 31.7725 31.5754 31.7634 31.335 31.6788L31.1912 31.6176L27.1237 29.5851L24 33.7501C23.8174 33.9936 23.5522 34.1621 23.2541 34.224C22.9561 34.2859 22.6457 34.237 22.3812 34.0863L22.25 34.0001C22.0064 33.8175 21.8379 33.5523 21.776 33.2542C21.7141 32.9562 21.7631 32.6458 21.9137 32.3813L22 32.2501L25.75 27.2501C25.9103 27.0365 26.1348 26.88 26.3905 26.8033C26.6463 26.7265 26.9199 26.7338 27.1712 26.8238L27.3087 26.8826L31.4225 28.9388L37.04 22.2001Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsComboFeature);
export default __webpack_public_path__ + "static/media/products_combo_feature.92398e7bbacb775551be68ea180c72e2.svg";
export { ForwardRef as ReactComponent };